<template>
  <div>
    <v-container class="pt-0">
      <pricelist-content />
    </v-container>
  </div>
</template>

<script>
import PricelistContent from "@/components/content/PricelistContent";

export default {
  name: "Pricelist",
  components: {
    PricelistContent
  },

  data: () => ({}),
  methods: {}
};
</script>
